import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { ProductContents } from '../components/ProductContents';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FaqSection } from '../components/FaqSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="flex flex-col min-h-screen w-full font-sans selection:bg-brand-lavender selection:text-brand-slate" data-id="element-196">
      <HeroSection data-id="element-197" />
      <ProblemSection data-id="element-198" />
      <FailedSolutions data-id="element-199" />
      <MechanismSection data-id="element-200" />
      <ProductContents data-id="element-201" />
      <AudienceSection data-id="element-202" />
      <HowItWorks data-id="element-203" />
      <ProofSection data-id="element-204" />
      <FaqSection data-id="element-205" />
      <OfferSection data-id="element-206" />
      <FooterSection data-id="element-207" />
    </main>;
}